<template>
    <div
        class="breadcrumb-card mb-25 d-md-flex align-items-center justify-space-between"
    >
        <h5 class="mb-0">
            {{ breadcrumbs?.[breadcrumbs.length - 1]?.label || '' }}
        </h5>

        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <!-- Sempre o início -->
            <li class="breadcrumb-item d-inline-block position-relative">
                <RouterLink to="/home" class="d-inline-block position-relative">
                    <i class="material-symbols-outlined">home</i>
                    {{ $t("common.topHeader.home") }}
                </RouterLink>
            </li>

            <!-- Demais caminhos -->
            <li
                v-for="(crumb, index) in breadcrumbs"
                :key="index"
                class="breadcrumb-item d-inline-block position-relative"
            >
                <template v-if="crumb.to && index < breadcrumbs.length - 1">
                    <RouterLink :to="crumb.to" class="pl-0 d-inline-block position-relative">
                        {{ crumb.label }}
                    </RouterLink>
                </template>
                <template v-else>
                    {{ crumb.label }}
                </template>
            </li>
        </ol>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "PageTitle",
    props: {
        breadcrumbs: {
            type: Array,
            default: () => [] // evita undefined
        }
    }
});
</script>
